  
class SubscriptionBox extends HTMLElement {
    constructor() {
        super();
        this.inp = this.querySelector('[data-subs-change]');
        this.sel = this.querySelector('[data-subs-select]');
        this.button = this.querySelector('[data-subs-apply]');
        this.quantity = this.closest('.cart-item').querySelector('.quantity__input').value;
        this.old = parseInt(this.dataset.subscription);
        this.original = parseInt(this.dataset.original);
        this.line = parseInt(this.dataset.line);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.isCart = false;
        this.cartMain  = false;
        if (this.dataset.templateCart === 'true') {
            this.isCart = true;
            this.cartMain = document.querySelector('cart-items');
        }
        this.inp.addEventListener('change', ()=>{
            this.inp.closest('[data-subscription]').classList.toggle('active')
        })
        this.button.addEventListener('click', ()=>{
            // this.addToCart(old)
            this.remove(this.line, 0)
        })
    }

    getSectionsToRender() {
        if ( this.isCart) {
            return [
                {
                    id: 'main-cart-items',
                    section: document.getElementById('main-cart-items').dataset.id,
                    selector: '.js-contents',
                },
                {
                    id: 'cart-icon-bubble',
                    section: 'cart-icon-bubble',
                    selector: '.shopify-section'
                },
                {
                    id: 'cart-live-region-text',
                    section: 'cart-live-region-text',
                    selector: '.shopify-section'
                },
                {
                    id: 'main-cart-footer',
                    section: document.getElementById('main-cart-footer').dataset.id,
                    selector: '.js-contents',
                }
                ];
        } else {
            return [
                {
                    id: 'cart-drawer',
                    selector: '#CartDrawer'
                },
                {
                    id: 'cart-icon-bubble',
                }
            ];
        }
        
    }

    remove(line, quantity) {
        const body = JSON.stringify({
            line,
            quantity
        });
        fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
        .then((response) => response.json())
        .then((response) => {
            this.add()
            
        }).catch((e) => {
            console.error(e);
        });
    }
    add(){
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        let formData = new FormData();

        formData.append('properties[shipping_interval_unit_type]',  this.sel.dataset.frequencyType);
        formData.append('properties[shipping_interval_frequency]',  this.sel.value);
        formData.append('quantity', this.quantity);
        formData.append('id', this.original);
        formData.append('sections', this.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;
  
        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then( (response)=>{
            // console.log(response)
            // console.log( this.getSectionsToRender())
            // this.isCart?this.renderMainCart(response):this.cart.renderContents(response);
            this.isCart?location.reload():this.cart.renderContents(response);

        })
    }

    // addToCart(old){
        
    //     let data = {
    //         items: [
    //             {
    //                 quantity: this.quantity,
    //                 id: this.original,
    //                 properties: {
    //                     'shipping_interval_unit_type':  this.sel.dataset.frequencyType,
    //                     'shipping_interval_frequency':  this.sel.value
    //                 }
    //             }
    //         ],
    //         sections: this.getSectionsToRender().map((section) => section.section),
    //         sections_url: window.location.pathname
    //     };
        
    //     fetch('/cart/add.js', {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/json;charset=utf-8'
    //         },
    //         body: JSON.stringify(data)
    //     })
    //     .then((response) => response.json())
    //     .then( ()=>{
    //         this.removeFromCart(this.line, 0)
    //     })
    //     // .then((response) => {
    //     //     fetch('/cart.js')
    //     //     .then(function(response) {
    //     //         return response.json();
    //     //     })
    //     //     .then(function(json) {
    //     //         const items = json.items
    //     //         console.log(items)
    //     //         // const index = items.findIndex((el) => el.id === old);
    //     //         return items.findIndex((el) => el.id === old)
               
    //     //     })
    //     //     .then(line => {
    //     //         setTimeout(() => {
    //     //             console.log(this.line)
    //     //             this.removeFromCart(line, 0)
    //     //         }, 1000);
                
    //     //         // this.removeFromCart(line, 0)
    //     //     });
    //     // })

    //     // if (response.status === 200) {
    //     //     this.removeFromCart(this.line, 0)
    //     // } else if (response.status === 422) { console.log('out of stock');
    //     // } else { console.log('product add error');}


    //     // .then((response) => response.json())
    //     // .then((response) => {
    //     //     fetch('/cart.js')
    //     //     .then(function(response) {
    //     //         return response.json();
    //     //     })
    //     //     .then(function(json) {
    //     //         const items = json.items
    //     //         const index = items.findIndex((el) => el.id === old);
    //     //         this.removeFromCart((this.line), 0)(index)
    //     //     })
    // }

    // removeFromCart(line, quantity) {
    //     const body = JSON.stringify({
    //         line,
    //         quantity,
    //         sections: this.getSectionsToRender().map((section) => section.section),
    //         sections_url: window.location.pathname
    //         });

    //     fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
    //     .then((response) => response.json())
    //     .then((response) => {
    //         console.log('product removed', line)
    //         this.isCart?this.renderMainCart(response):this.cart.renderContents(response);
            
    //       }).catch((e) => {
    //         console.error(e);
    //       });   
    // }

    renderMainCart(parsedState){
        // location.reload();
        this.getSectionsToRender().forEach((section => {
            console.log(section.id)
            const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML =
                this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
    }
    
    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
    }

}
  
customElements.define('subscription-box', SubscriptionBox);